import {
  BreakpointObserver,
  Breakpoints,
  BreakpointState,
} from "@angular/cdk/layout";
import { Component, OnDestroy, OnInit, inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { Subject, takeUntil, tap } from "rxjs";
import { isMobile, isNotMobile } from "./core/store/layout/actions";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "app-root",
    styles: [],
    template: ` <app-layout [appTitle]="title" /> `,
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  private breakpointObserver = inject(BreakpointObserver);
  private store = inject(Store);
  private translateSvc = inject(TranslateService);

  title = "Impacto";

  destroyed = new Subject<void>();

  ngOnInit(): void {
    // init language
    if (!this.translateSvc.currentLang) {
        var browserLang = this.translateSvc.getBrowserLang();
        this.translateSvc.use(browserLang ?? 'en');
    }

    // set Breakpoints.Small min-width equal to bootstrap sm breakpoint
    // default values:
    // Breakpoints.Small (min-width: 600px) and (max-width: 959.98px)
    // Breakpoints.Medium (min-width: 960px) and (max-width: 1279.98px)

    Breakpoints.Small = '(min-width: 576px) and (max-width: 767.98px)'
    Breakpoints.Medium = '(min-width: 768px) and (max-width: 1279.98px)'

    this.breakpointObserver
      .observe([Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
      .pipe(
        takeUntil(this.destroyed),
        tap((value: BreakpointState) =>
          value.matches ? this.store.dispatch(isNotMobile()) : this.store.dispatch(isMobile())
        )
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }

}
